export function getUserDisplayName(user) {
    return user.authTwitch?.login || user.email.split('@')[0] || 'Host';
}
//# sourceMappingURL=getUserInfo.js.map